import React from 'react';
import { Anchor } from '@zillow/constellation';
import { CUSTOMER_SUPPORT_LINK } from '../../../constants/urls';

const CustomerSupportLink = (
  <Anchor target="_blank" href={CUSTOMER_SUPPORT_LINK}>
    Customer Support
  </Anchor>
);

export default CustomerSupportLink;
